import { useEffect, useState } from "react";
import axios from "axios";

const PRODUCT = "WasteHQ";
let cache = { product: PRODUCT, company_name: PRODUCT };

/** Sync getters — safe anywhere because BrandingGate renders children only after load. */
export const product = () => PRODUCT;
export const company = () => cache.company_name || PRODUCT;
export const brand = () => cache;
export const setBrandCache = (b) => { cache = { ...cache, ...b }; };

export function BrandingGate({ children }) {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        const done = () => setReady(true);
        const t = setTimeout(done, 2500);
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/branding`)
            .then(({ data }) => {
                setBrandCache(data);
                const path = window.location.pathname;
                const publicPage = /^\/(signup|embed\/|portal|pay|agreement)/.test(path);
                if (publicPage) document.title = company();
            })
            .catch(() => {})
            .finally(() => { clearTimeout(t); done(); });
        return () => clearTimeout(t);
    }, []);
    return ready ? children : null;
}
